/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const selectableListTokens = {
  ContainerBackgroundColorBaseDefault: '#ffffff',
  ContainerBackgroundColorBaseDisabled: '#ebecec',
  ContainerBorderColorBaseDefault: '#c4c4c4',
  ContainerBorderColorBaseHover: '#394040',
  ContainerBorderColorBaseKeyboardFocus: '#285da3',
  ContainerBorderColorDisabledDefault: '#ebecec',
  ContainerBorderColorInvalidDefault: '#c41936',
  ContainerBorderColorCheckedDefault: '#000000',
  ContainerBorderColorCheckedDisabled: '#dedfdf',
  ContainerBorderRadiusBaseDefault: '12px',
  ContainerBorderWidthBaseDefault: '1px',
  ContainerBorderWidthBaseHover: '1px',
  ContainerBorderWidthDisabledDefault: '1px',
  ContainerBorderWidthInvalidDefault: '1px',
  ContainerBorderWidthCheckedDefault: '2px',
  ContainerShadowColorBaseKeyboardFocus: '#8babd6',
  ContainerShadowColorInvalidKeyboardFocus: '#e9778a',
  ContainerShadowWidthBaseKeyboardFocus: '4px',
  ContainerShadowWidthInvalidKeyboardFocus: '4px',
  ContainerSpacingGapBaseDefault: '16px',
  ContainerSpacingGapCompactDefault: '12px',
  ContainerSpacingPaddingBaseDefault: '16px',
  ContainerSpacingPaddingCompactDefault: '12px',
  ContainerFontColorDisabledDefault: '#a7aaaa',
  ControlBackgroundColorDisabledDefault: '#ebecec',
  ControlSizeBaseDefault: '50px',
} as const;
